import React, { useMemo } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { ErrorMessage, Field, Formik, Form as FormikForm } from 'formik';
import { t } from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { upperFirst } from 'lodash';
import { toast } from 'react-toastify';

import RequiredAstric from '../../../components/DynamicForm/required-astric';

import { setExaminationsDetails } from '../../../redux/examination/slice';
import { createExamination, updateExamination } from '../../../redux/examination';

import { getExaminationValidationSchema } from './validation';

const ExaminationModel = ({ show, close, fetch, type }) => {
	const { examinationsDetails } = useSelector(state => state.examinations);
	const dispatch = useDispatch();
	const isEdit = useMemo(() => Boolean(examinationsDetails?.id), [examinationsDetails]);

	const handleClose = () => {
		close();
		dispatch(setExaminationsDetails(null));
	};

	const handleSubmit = async(values, { setSubmitting, resetForm }) => {
		try {
			const action = isEdit && examinationsDetails.id
				? updateExamination({ body: values, id: examinationsDetails.id })
				: createExamination({
					...values,
					type,
				});

			await dispatch(action).unwrap();
			handleClose();
			resetForm();
			fetch();
		} catch (error) {
			toast.error(error.message);
			return error;
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" centered >
			<Modal.Header closeButton>
				<Modal.Title>{t(`GENERAL.${isEdit ? 'UPDATE' : 'ADD'}`)} {t('EXAMINATIONS.TITLE', { type: upperFirst(type) })}</Modal.Title>
			</Modal.Header>

			<Formik
				initialValues={{
					name: examinationsDetails?.name || '',
					status: examinationsDetails?.status?.toLowerCase() || 'active',
				}}
				validationSchema={getExaminationValidationSchema(t)}
				enableReinitialize={true}
				onSubmit={handleSubmit}
			>
				{({ isSubmitting }) => (
					<FormikForm>
						<Modal.Body>
							<Row className="mb-3">
								<Form.Group>
									<Form.Label>{t('GENERAL.NAME')} <RequiredAstric /></Form.Label>
									<Field name="name" as={Form.Control} />
									<div className="text-danger small"><ErrorMessage name="name" /></div>
								</Form.Group>
							</Row>

							<Row className="mb-3">
								<Form.Group>
									<Form.Label>{t('GENERAL.STATUS')}</Form.Label>
									<Field name="status" as="select" className="form-select">
										<option value="active">{t('GENERAL.ACTIVE')}</option>
										<option value="inactive">{t('GENERAL.INACTIVE')}</option>
									</Field>
									<div className="text-danger small"><ErrorMessage name="status" /></div>
								</Form.Group>
							</Row>

							<Row className="mb-3">
								<Col>
									<Button type="submit" className='px-3 py-2 me-2' variant="primary" disabled={isSubmitting}>
										{isSubmitting ? t('GENERAL.SAVING') : isEdit ? t('GENERAL.UPDATE') : t('GENERAL.SUBMIT')}
									</Button>
									<Button variant="danger" className='px-3 py-2' onClick={handleClose}>{t('GENERAL.CANCEL')}</Button>
								</Col>
							</Row>
						</Modal.Body>
					</FormikForm>
				)}
			</Formik>
		</Modal >
	);
};

export default ExaminationModel;
